import React from "react";
import dayjs from "dayjs";
import { StyrandeDokument } from "./models";

interface Props {
  item: StyrandeDokument;
}
export const SearchResultVardhandboken: React.VFC<Props> = ({ item }) => {
  /*********************************
   * Render
   *********************************/
  return (
    <article className="vgr-searchservice-item">
      <header>
        <div className="vgr-searchservice-item__heading-wrapper">
          <a className="vgr-searchservice-item__header-link" href={item.url}>
            {globeIcon}
            <h3 className="vgr-searchservice-item__heading">{item.title}</h3>
          </a>
        </div>

        <h4 className="vgr-searchservice-item__sub-heading">
          {dayjs(item.revisionDate).format("D MMMM YYYY")} • {item.source} •
          Extern webbplats
        </h4>
      </header>
      <div className="vgr-searchservice-item__body">
        <details>
          <summary>
            <span>
              <span className="title-show">Visa</span>
              <span className="title-hide">Dölj</span> mer uppgifter
              <span className="sr-only">om webbplatsen {item.title}</span>
            </span>{" "}
            {chevron}
          </summary>
          {item.category != null && (
            <div>
              <div className="vgr-searchservice-item__datawrapper">
                <strong>Vårdhandbokens kategorier</strong>
                {item.category.map((cat, index) => {
                  const separator = index ? ", " : "";
                  return (
                    <span key={`vardhandboken_category_${cat}`}>
                      {separator + cat}
                    </span>
                  );
                })}
              </div>
            </div>
          )}
        </details>

        {item.descriptionVardhandboken && (
          <div
            className="vgr-searchservice-item__description"
            dangerouslySetInnerHTML={{ __html: item.descriptionVardhandboken }}
          ></div>
        )}
      </div>
    </article>
  );
};

const chevron = (
  <svg aria-hidden={true} style={{ width: "16px", height: "16px" }}>
    <use xlinkHref="#streamline-arrow"></use>
  </svg>
);

const globeIcon = (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1898_1177)">
      <path
        d="M12.1148 24C11.1506 24 10.1835 23.884 9.24054 23.656C9.21025 23.651 9.17997 23.644 9.15069 23.634C6.18257 22.899 3.61121 21.068 1.92928 18.485C1.88486 18.433 1.8475 18.375 1.81923 18.314C0.628959 16.416 0 14.234 0 12C0 9.766 0.628959 7.584 1.81823 5.687C1.8475 5.625 1.88486 5.567 1.92928 5.514C3.60616 2.938 6.16945 1.11 9.14968 0.365C9.18401 0.354 9.22035 0.346 9.25669 0.34C10.1956 0.114 11.1567 0 12.1148 0C13.0728 0 14.035 0.115 14.9728 0.34C15.0082 0.346 15.0445 0.354 15.0778 0.365C18.0591 1.11 20.6214 2.938 22.2993 5.514C22.3447 5.567 22.382 5.624 22.4113 5.687C23.6006 7.584 24.2295 9.766 24.2295 12C24.2295 14.234 23.6006 16.416 22.4113 18.313C22.382 18.375 22.3447 18.433 22.2993 18.485C20.6173 21.068 18.046 22.899 15.0546 23.64C15.0445 23.644 15.0173 23.65 14.988 23.655C14.0461 23.884 13.0789 24 12.1148 24ZM9.84729 22.255C10.5964 22.417 11.3576 22.5 12.1148 22.5C12.8719 22.5 13.6332 22.417 14.3823 22.255C14.9506 21.355 15.4443 20.153 15.8229 18.75H8.40664C8.78523 20.154 9.2789 21.355 9.84729 22.255ZM17.3968 18.75C17.1363 19.792 16.8173 20.74 16.4428 21.582C17.9036 20.934 19.1898 19.971 20.2256 18.75H17.3968ZM4.00393 18.75C5.03874 19.971 6.32593 20.934 7.78576 21.582C7.41121 20.74 7.09219 19.792 6.83172 18.75H4.00393ZM21.2917 17.25C22.0933 15.88 22.5708 14.336 22.6849 12.75H18.1611C18.1247 14.322 17.9763 15.832 17.7189 17.25H21.2917ZM16.1692 17.25C16.4428 15.841 16.6063 14.299 16.6457 12.75H7.58385C7.62322 14.3 7.78677 15.842 8.06036 17.25H16.1692ZM6.51068 17.25C6.25324 15.832 6.10484 14.322 6.06849 12.75H1.54463C1.65871 14.336 2.13624 15.88 2.93783 17.25H6.51068ZM22.6849 11.25C22.5708 9.664 22.0933 8.12 21.2917 6.75H17.7189C17.9763 8.168 18.1247 9.678 18.1611 11.25H22.6849ZM16.6457 11.25C16.6063 9.701 16.4428 8.159 16.1692 6.75H8.06036C7.78677 8.159 7.62423 9.701 7.58385 11.25H16.6457ZM6.06849 11.25C6.10484 9.678 6.25324 8.168 6.51068 6.75H2.93783C2.13624 8.12 1.65871 9.664 1.54463 11.25H6.06849ZM20.2256 5.25C19.1908 4.029 17.9036 3.066 16.4428 2.418C16.8163 3.26 17.1363 4.207 17.3968 5.25H20.2256ZM15.8229 5.25C15.4443 3.847 14.9506 2.645 14.3823 1.745C13.6332 1.582 12.8709 1.5 12.1148 1.5C11.3586 1.5 10.5964 1.583 9.84729 1.745C9.2789 2.645 8.78523 3.846 8.40664 5.25H15.8229ZM6.83273 5.25C7.0932 4.208 7.41222 3.26 7.78677 2.418C6.32593 3.066 5.03874 4.029 4.00393 5.25H6.83273Z"
        fill="#006298"
      />
    </g>
    <defs>
      <clipPath id="clip0_1898_1177">
        <rect width="24.2295" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
